exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  margin-top: 5px;\n  border-top: 2px solid #747f8f;\n  height: 11%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column; }\n  :host .lane {\n    background-color: black;\n    height: 50%;\n    width: 200%;\n    overflow: hidden; }\n    :host .lane.lane-1 {\n      border-bottom: 2px solid #747f8f; }\n    :host .lane vit-number {\n      width: calc(5% - 9px);\n      height: calc(100% - 4px);\n      padding: 2px;\n      float: left; }\n      :host .lane vit-number:last-of-type {\n        transform: rotate(720deg);\n        margin-left: 100%; }\n      :host .lane vit-number.rollIn {\n        margin-left: 0 !important;\n        transform: rotate(0deg) !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/game-view/rolling-numbers/rolling-numbers.component.scss
// module id = ../../../../../src/app/game-view/rolling-numbers/rolling-numbers.component.scss
// module chunks = 1